<script>
  export default {
    name: "ToolsPage"
  }
</script>

<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
